
import HttpClient from '../HttpService';

function toggleStatus(companyId) {
    return HttpClient.put(`/sellers/${companyId}/toggle/status`);
}

function getById(companyId) {
    return HttpClient.get(`/sellers/${companyId}`);
}

function create(data) {
    return HttpClient.post(`/sellers/`, data);
}

function list(page, limit, data) {
    return HttpClient.post(`/sellers/list?page=${page}&limit=${limit}`, data);
}

function update(data) {
    return HttpClient.put(`/sellers/${data.id}`, data);
}

function destroy(companyId) {
    return HttpClient.delete(`/sellers/${companyId}`);
}

export default {
    destroy,
    list,
    create,
    update,
    toggleStatus,
    getById
}
